




























































import Vue from 'vue';
import TabsRow from './tabs-row.vue';
import {ItineraryPreferenceTab, tabItems} from './itinerary-preferences-helper';
import ItineraryPreferencesTravelers from './tabs/itinerary-preferences-travelers.vue';
import ItineraryPreferencesPlaces from './tabs/itinerary-preferences-places.vue';
import ItineraryPreferencesMeals from './tabs/itinerary-preferences-meals.vue';
import ItineraryPreferencesTiming from './tabs/itinerary-preferences-timing.vue';
import ItineraryPreferencesTransit from './tabs/itinerary-preferences-transit.vue';
import ItineraryPreferencesDayPlans from './tabs/itinerary-preferences-day-plans.vue';
import ItineraryPreferencesBudget from './tabs/itinerary-preferences-budget.vue';
import UpdatePreferencesChangesBlock from './block/update-preferences-changes-block.vue';
import IssueInformationBlock from './block/issue-information-block.vue';
import {ItineraryPreferencesModule} from '@/store/modules';

export default Vue.extend({
  name: 'ItineraryPreferences',
  components: {
    TabsRow,
    ItineraryPreferencesTravelers,
    ItineraryPreferencesPlaces,
    ItineraryPreferencesMeals,
    ItineraryPreferencesTiming,
    ItineraryPreferencesTransit,
    ItineraryPreferencesDayPlans,
    ItineraryPreferencesBudget,
    UpdatePreferencesChangesBlock,
    IssueInformationBlock,
  },
  props: {},
  data() {
    return {
      currentTab: ItineraryPreferenceTab.PLACES as ItineraryPreferenceTab | undefined,
      ItineraryPreferenceTab,
      tabItems,
      isPreferencesUpdated: false,
      itineraryPreferences: ItineraryPreferencesModule.get(),
    };
  },
  computed: {},
  methods: {
    onTabSelected(tabName: ItineraryPreferenceTab) {
      this.currentTab = tabName;
    },
    onPreferencesChanged(value: object, tabName: string) {
      // @ts-ignore-next-line
      this.itineraryPreferences[tabName as keyof typeof ItineraryPreferences] = value;
      this.isPreferencesUpdated = true;
    },
    onUpdatePreferencesClick() {
      // @ts-ignore-next-line
      window.store = useStore();
      ItineraryPreferencesModule.save(this.itineraryPreferences);
      // TODO: update itinerary preferences!
      this.isPreferencesUpdated = false;
    },
  },
});
